import routerOptions0 from "/codebuild/output/src713373481/src/dashboard/node_modules/.pnpm/nuxt@3.21.2_@netlify+blobs@9.1.0_@parcel+watcher@2.5.1_@types+node@20.19.37_@vue+compil_44e3706e5d67da642fee589c685480b5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}